import {
  createApi,
  fetchBaseQuery,
  FetchBaseQueryError,
  retry,
} from '@reduxjs/toolkit/query/react';
import type { RootState } from '../../../../app/store';
import config from '../../../../config';
import { CACHE_EXPIRE_TIME_S } from './apiConstants';

const API_URL = config.api.bloomfieldApiUrl;

// Define a service using a base URL and base query behavior
export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: retry(
    fetchBaseQuery({
      baseUrl: API_URL,
      prepareHeaders: async (headers, { getState }) => {
        const access_token = (getState() as RootState).auth.apiToken;
        if (access_token) {
          headers.set('Authorization', `Bearer ${access_token}`);
        }
        return headers;
      },
    }),
    {
      retryCondition: (error: FetchBaseQueryError, _, { attempt }) => {
        if (attempt > 3) {
          return false;
        }

        if (typeof error.status === 'number') {
          if (error.status > 499 && error.status < 600) {
            return true;
          }
        }

        if (
          error.status === 'TIMEOUT_ERROR' ||
          error.status === 'FETCH_ERROR'
        ) {
          return true;
        }

        return false;
      },
    }
  ),
  keepUnusedDataFor: CACHE_EXPIRE_TIME_S, // time to keep cached data for
  refetchOnMountOrArgChange: CACHE_EXPIRE_TIME_S, // refetch data when the query is mounted or the arg changes, if it has been at least this long since the last fetch
  tagTypes: [
    'Customer',
    'Ranch',
    'Block',
    'User',
    'Scan',
    'BasePoint',
    'Point',
    'RowSide',
    'QAStatus',
    'QAQuality',
    'GlitchType',
    'ScanGlitch',
    'PointDetection',
    'scanDataSignedCookie',
    'Camera',
    'CameraMovementLog',
    'Collection',
    'Alley',
    'Upload',
    'Variety',
  ],
  endpoints: () => ({}), // All endpoints will be injected in other files
});
